// @flow
import { httpClient } from 'angieslist-app-platform';

export default {
  createAccount: (email: string, entityId: string, entityHash: string): Promise<any> =>
    httpClient.post(`/gateway/service-provider-management/v1/angiLeads/${entityId}/account/create`, {
      headers: {
        'X-ANGI-EntityHash': entityHash,
      },
      body: {
        email,
      },
    }),
  linkAccounts: (leadsUserId: number, adsUserId: number, entityHash: string): Promise<any> =>
    httpClient.post(`/gateway/service-provider-management/v1/angiLeads/${leadsUserId}/account/link`, {
      headers: {
        'X-ANGI-EntityHash': entityHash,
      },
      body: {
        leadsUserId,
        adsUserId,
      },
    }),
  linkBusiness: (username: string, password: string): Promise<any> =>
    httpClient.post('/gateway/service-provider-management/v1/angiLeads/account/link-business', {
      body: { username, password },
    }),
};



// WEBPACK FOOTER //
// ./src/modules/sync/common/accountSyncService.js